import React from "react";
import GeneralStrings from "../../../strings/GeneralStrings.json";
import { Field } from "formik";
import FormikRadioGroup from "../../FormikRadioGroup/FormikRadioGroup";

const PoolTypeStep = () => {
  const POOL_TYPE_STEP_STRINGS =
    GeneralStrings.ENROLL.FORM_LABELS.POOL_TYPE_STEP;

  const options = ["Public", "Private"];

  return (
    <div className="step">
      <h4 className="step-header">{POOL_TYPE_STEP_STRINGS.HEADER}</h4>
      <div className="question-container">
        <Field
          className="form-group"
          name="poolType"
          options={options}
          component={FormikRadioGroup}
        />
      </div>
    </div>
  );
};

export default PoolTypeStep;
